import { PERMISSIONS } from '../../constants';
import list from './ChargeSessionsReport';

export default {
  list,
  name: 'report-charge-sessions',
  permissions: [PERMISSIONS.ADMIN],
};
